import {trackJourneyStep} from './journey-logger'
import {GuestCheckoutError, type GuestCheckoutErrorCode} from '../services/guest-checkout.service'

// The registered journey reason for each refusal a Guest Checkout preview can return.
const PREVIEW_REJECTION_REASONS: Partial<Record<GuestCheckoutErrorCode, string>> = {
    full: 'capacity_full',
    guest_holds_busy: 'guest_holds_busy',
    login_required: 'login_required',
    not_found: 'context_not_found',
    payment_unavailable: 'payment_unavailable',
    rate_limited: 'rate_limited',
    registration_closed: 'registration_closed',
}

/** A signed-out visitor opened the choice between booking without an account and signing in. */
export function trackGuestCheckoutChooserOpened(): void {
    trackJourneyStep({feature: 'guest_checkout', action: 'chooser', stage: 'opened', outcome: 'none', measurement: 'none', metricOwner: 'none'})
}

/** The guest form opened after a successful preview. */
export function trackGuestCheckoutStarted(): void {
    trackJourneyStep({feature: 'guest_checkout', action: 'checkout', stage: 'started', outcome: 'success', measurement: 'funnel_start', metricOwner: 'frontend'})
}

/** The preview was refused or failed, so the guest never saw the form. */
export function trackGuestCheckoutRejected(failure: unknown): void {
    const reasonCode = failure instanceof GuestCheckoutError ? PREVIEW_REJECTION_REASONS[failure.code] : undefined
    trackJourneyStep({feature: 'guest_checkout', action: 'checkout', stage: 'rejected', outcome: 'rejected', measurement: 'none', metricOwner: 'none', reasonCode: reasonCode ?? 'booking_failed'})
}
